'use strict';

var formHelpers = require('../checkout/formErrors');
const { getPidValue } = require('./common');

/**
 * Scrolls to the Notify Me error target (email field).
 *
 * @param {jQuery} form - Fallback form container.
 * @returns {void}
 */
function scrollNotifyMeErrorIntoView(form) {
    var $target = $('.product-detail [data-attr="size"]').first();

    if (!$target.length) {
        $target = form.find('#notify-me-form-email');
    }

    if (!$target.length) {
        return;
    }

    var headerHeight = $('header').outerHeight() || 0;
    var targetTop = Math.max($target.offset().top - headerHeight - 24, 0);

    $('html, body').animate({
        scrollTop: targetTop
    }, 500);
}

/**
 * Loads and displays the Notify Me form inline on PDP.
 * @param {jQuery} button - The clicked Notify Me button element.
 */
function handleNotifyMe(button) {
    const url = button.data('url');
    const productId = getPidValue(button);

    const $container = $('.notify-me-container');
    const $formWrapper = $container.find('.notify-me-form');

    $.ajax({
        url: url,
        method: 'POST',
        data: { pid: productId },
        dataType: 'html',
        success: function (response) {
            $formWrapper.empty().append($.parseHTML(response));
            $container.removeClass('d-none');

            $('.prices-add-to-cart-actions').css('opacity', 0);
        }
    });
}

module.exports = {
    notifyMeButton: function () {
        $('body').on('click', '.js-notify-me', function (e) {
            e.preventDefault();
            e.stopPropagation();
            handleNotifyMe($(this));
        });
    },
    notifyMeForm: function () {
        $('body').off('click', '.js-get-notified').on('click', '.js-get-notified', function (e) {
            e.preventDefault(); // Prevent the default form submission
            var form = $('#notifyMeForm');
            var url = form.attr('action');
            var formData = form.serialize(); // Serialize form data

            formHelpers.clearPreviousErrors($('.notify-me-form-content'));

            $.ajax({
                url: url,
                method: 'POST',
                data: formData,
                dataType: 'json',
                success: function (response) {
                    if (response.error) {
                        if (response.fieldErrors.length) {
                            response.fieldErrors.forEach(function (error) {
                                if (Object.keys(error).length) {
                                    $.each(error, function (attr, message) {
                                        var $input = form.find('*[name=' + attr + ']');

                                        $input
                                            .addClass('is-invalid')
                                            .siblings('.invalid-feedback')
                                            .html(message);
                                    });
                                }
                            });

                            const $emailField = form.find('#notify-me-form-email');
                            if ($emailField.hasClass('is-invalid') && window.innerWidth > 543) {
                                scrollNotifyMeErrorIntoView(form);
                            }
                        }
                    } else {
                        const $container = $('.notify-me-container').find('.notify-me-form');
                        $container.html(
                            '<div class="notify-me-success text-center mt-4">' +
                            response.message +
                            '</div>'
                        );
                    }
                }
            });

            setTimeout(function () {
                $('.notify-me-message').remove();
            }, 3000);
        });
    },
    handleNotifyMe: handleNotifyMe
};
